import { IPromoInfoSchema } from '../../repositories/newbuilding-card/entities/promo/PromoInfoSchema';
import { IApplicationState } from '../../types/redux';

export const selectPromoInfo = (state: IApplicationState): IPromoInfoSchema | null => {
  return state.promoInfo.promo;
};
